
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7 8"}},[_c('path',{attrs:{"d":"M0 7.563V.436C0 .04.584-.112.908.088l5.806 3.545c.322.202.403.531.081.733L.867 7.911C.545 8.113 0 7.958 0 7.563z"}})])
      }
    
      }
    